import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BIIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BI" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Rect width={16} height={12} fill="#5EAA22" rx={1} />
      <Mask
        id="b"
        width={24}
        height={16}
        x={-4}
        y={-2}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M-4-2h24v16H-4z" />
        <Path
          fillRule="evenodd"
          d="M16 0H0l8 6-8 6h16L8 6l8-6Z"
          clipRule="evenodd"
        />
      </Mask>
      <Path
        fill="#DD2C2B"
        fillRule="evenodd"
        d="M16 0H0l8 6-8 6h16L8 6l8-6Z"
        clipRule="evenodd"
      />
      <Path
        fill="#fff"
        d="M0 0v-1.25h-3.75l3 2.25L0 0Zm16 0 .75 1 3-2.25H16V0ZM0 12l-.75-1-3 2.25H0V12Zm16 0v1.25h3.75l-3-2.25-.75 1ZM0 0v1.25h16v-2.5H0V0Zm8 6 .75-1-8-6L0 0l-.75 1 8 6L8 6Zm0 0-.75-1-8 6L0 12l.75 1 8-6L8 6Zm-8 6v1.25h16v-2.5H0V12Zm16 0 .75-1-8-6L8 6l-.75 1 8 6 .75-1Zm0-12-.75-1-8 6L8 6l.75 1 8-6L16 0Z"
        mask="url(#b)"
      />
      <Path
        fill="#fff"
        fillRule="evenodd"
        d="M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        clipRule="evenodd"
      />
      <Path
        fill="#DD2C2B"
        fillRule="evenodd"
        d="m8.084 5.214-.588.31.112-.655-.476-.464h.658l.294-.69.293.69h.658l-.476.464.112.654-.587-.309ZM6.681 7.214l-.588.31.113-.655-.476-.464h.657l.294-.69.294.69h.657l-.475.464.112.654-.588-.309ZM9.481 7.214l-.588.31.113-.655-.476-.464h.657l.294-.69.294.69h.657l-.475.464.112.654-.588-.309Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
